
import React, { useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col } from "react-bootstrap";

import ConsultaOpcoesDesvios from '../../../../../lib/json/consultas/OpcoesDesvios.json'
import ConsultaTituloDesvios from '../../../../../lib/json/consultas/TituloDesvios.json'

import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import {ConsultaAPI} from "../../../../../backend/ConsultaAPI";
import SubmitForm from "../../../../components/SubmitForm";
import { ConsumoAPI_POST, ConsumoAPI_PUT } from "../../../../../backend/ConsumoAPI";
import { SucessoMsg } from "../../../../contents/VariaveisGlobais";
import SelectDinamico from "../../../../components/SelectDinamico";
import { toast } from "react-toastify";

function FichaOpcoesDesvios(){
    const navigate = useNavigate();
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    var [inclusao, setInclusao] = useState(true);

    const { idOpcoesDesvios } = useParams();

    // Consulta do grid
    var consultaDefault  = ConsultaOpcoesDesvios.consulta + (idOpcoesDesvios ? ` WHERE DSO.Id = '${idOpcoesDesvios}'` : '');

    var [campoDescricao, setCampoDescricao]   = useState([]);
    var [campoTituloDesvios, setCampoTituloDesvios]   = useState([]);

    useEffect(() => {
        if (idOpcoesDesvios){
            setInclusao(false)
            loadOpcoesDesvios();
        }
    }, []);

    // Processa consulta do grid
    const loadOpcoesDesvios = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaAPI( consultaDefault );
        
        if (retConsulta.data){
            setCampoDescricao(retConsulta.data[0].Nome);
            setCampoTituloDesvios({value: retConsulta.data[0].DesviosId, label : retConsulta.data[0].NomeDesvios});
        }
        
        setCarregar(false);
    }

    const handleSalvar = async() =>{
        try {
            // Verificar se todos os campos obrigatórios foram preenchidos
            if (!campoDescricao || !campoTituloDesvios.value) {
                toast.warning('O prenchimento dos campos são obrigatórios.');
                return;
            }

            setCarregar(true);
            const rota = 'opcoesDesvios' + (inclusao ? '' : '/' + idOpcoesDesvios);
    
            const retConsumo = await (inclusao
                ? ConsumoAPI_POST(rota, { nome: campoDescricao, desvios: campoTituloDesvios.value })
                : ConsumoAPI_PUT(rota, { nome: campoDescricao, desvios: campoTituloDesvios.value }));
    
            SucessoMsg(retConsumo.description);
        } catch (error) {
            console.error('Error in handleSalvar:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Opcões Desvios"/>
            </Col>
            <Col md="8" xs="12">
                <InputGeral 
                    label="Descrição"
                    tipo='text'
                    value={campoDescricao}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoDescricao(e.target.value)}
                />
            </Col>
            <Col md="4" xs="12">
                <SelectDinamico 
                    label="Título Desvios"
                    consulta={ConsultaTituloDesvios.consulta}
                    tabela={ConsultaTituloDesvios.tabelas}
                    cValue="Id"
                    cText='Id + " - " + item.Nome'
                    isMultiplo={false}
                    campoValue={campoTituloDesvios}
                    value={campoTituloDesvios}
                    onchange={(e) => setCampoTituloDesvios(e)}
                />
            </Col>
        </Row>
        
        <SubmitForm onSave={handleSalvar} onCancel={"handleCancelar"}></SubmitForm>
        </>
    );
}

export default FichaOpcoesDesvios;